import * as React from "react";
import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";
import { OnboardingMembersInfoItem } from "./OnboardingMembersInfoItem";

interface IOnboardingMembersInfoListProps {
  multiOrder: IMultiOrderOrchestrator | undefined;
  isMulti: boolean;
  screenVariant?: "failed" | "success";
}

export function OnboardingMembersInfoList({
  multiOrder,
  isMulti,
  screenVariant,
}: IOnboardingMembersInfoListProps) {
  return (
    <div className="flex mb-3 gap-2 relative items-center scrollbar-width-none webkit-scrollbar-none ms-overflow-style-none only-mobile:w-[calc(100vw-45px)] only-mobile:overflow-y-hidden only-mobile:whitespace-nowrap only-mobile:h-[50px]">
      {multiOrder?.multiOrderItems?.map((item, index) => {
        const currentMultiOrderItem = multiOrder.currentMultiOrderItem;

        if (!currentMultiOrderItem) {
          return;
        }

        const isActive = isMulti
          ? index + 1 <= currentMultiOrderItem
          : index + 1 === currentMultiOrderItem;

        const isMigrationFailed =
          screenVariant === "failed"
            ? index + 1 < currentMultiOrderItem
            : index + 1 <= currentMultiOrderItem;

        const currentMsisdn =
          screenVariant === "failed" &&
          index + 1 === currentMultiOrderItem &&
          !item?.verifiedMsisdn
            ? formatPhoneNumber(
                sessionStorage.getItem("migrationMsisdn"),
                POSITIVE_DIGITS,
                " ",
                "",
                true,
              ) || `numer ${index + 1} z ${multiOrder?.multiOrderItemsCount}`
            : formatPhoneNumber(
                item?.verifiedMsisdn,
                POSITIVE_DIGITS,
                " ",
                "",
                true,
              ) || `numer ${index + 1} z ${multiOrder?.multiOrderItemsCount}`;

        return (
          <OnboardingMembersInfoItem
            badge={isMigrationFailed ? "w trakcie" : undefined}
            isActive={isActive}
            isError={screenVariant === "failed" && isActive}
            key={`member-${index + 1}`}
            label={currentMsisdn}
            testId="label-with-number"
          />
        );
      })}
    </div>
  );
}
